import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import styles from './PlaceCard.module.scss';
import Paragraph from '../../../../components/Typography/Paragraph/Paragraph';
const PlaceCard = ({ title, horseName, prize }) => {
    return (_jsxs("div", Object.assign({ className: cn(styles.element) }, { children: [_jsxs("div", { children: [_jsx(Paragraph, { title: title, color: 'grey', size: 1, fontFamily: 'urbanist' }), _jsx(Paragraph, { title: horseName, color: 'black', size: 2, fontFamily: 'marope' })] }), _jsx("div", { children: _jsx(Paragraph, { title: prize, size: 5, color: 'black', fontFamily: 'marope' }) })] })));
};
export default PlaceCard;
